import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "ui/components/card";
import { Separator } from "ui/components/separator";
import { useQuery } from "@tanstack/react-query";
import ActivityList from "@/modules/work/billables/activity/components/list";
import ActivityEditor from "@/modules/work/billables/activity/components/editor";
import {
  createTicketActivity,
  fetchTicketActivities,
} from "@/modules/support/ticket/api";

import { invalidateAllQueries } from "utils/utils";
import Loader from "@/components/loader";
import { ErrorState } from "@/components/states";

export default function TicketActivity({ ticketId, canReply }) {
  const {
    data: activities = [],
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["tickets", ticketId, "activities"],
    queryFn: () => fetchTicketActivities(ticketId),
    enabled: !!ticketId,
  });

  async function handleSubmit({ message, attachment }) {
    await createTicketActivity({
      item: {
        collection: "tickets",
        item: ticketId,
        comment: message,
        attachment,
      },
    });

    invalidateAllQueries();
  }

  if (isLoading) return <Loader />;
  if (isError)
    return (
      <ErrorState title="Error loading activity" message={error?.message} />
    );

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">Activity</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <ActivityList activities={activities} />
        {canReply && (
          <>
            <Separator />
            <ActivityEditor onSubmit={handleSubmit} />
          </>
        )}
      </CardContent>
    </Card>
  );
}
